import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonOlList from '../../../common-components/common-ol-list';
import CommonSmallText from '../../../common-components/common-small-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const mtsInvestList = {
    colorNumber: '#e51908',
    list: [
        'Анализ продвигаемой семантики в&nbsp;разрезе конкурентов',
        'Дублирующиеся страницы в&nbsp;индексе',
        'Служебные и&nbsp;несуществующие страницы в&nbsp;индексе',
        'Общий анализ структуры поискового трафика',
        'Скорость загрузки различных типов страниц сайта',
        'Ошибки в&nbsp;HTML-коде сайта',
    ],
};

const TechAudit = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="mts-invest-tech-audit">
                <CommonTitle className="mts-invest-tech-audit__title">
                    <div className="mts-invest-tech-audit__title-decor">
                        <img
                            src="/images/svg/mts-invest/tech-audit__decor.svg"
                            alt=""
                            loading="lazy"
                        />
                    </div>
                    <span>Технический аудит проекта</span>
                </CommonTitle>
                <div className="mts-invest-tech-audit__text">
                    <CommonUsualText className="mts-invest-tech-audit__info">
                        Важной частью поисковой оптимизации проекта является оптимизация его
                        технической части: корректность перелинковки, хорошая скорость загрузки,
                        наличие правильных sitemap и&nbsp;robots.txt, отсутствие битых ссылок. Все
                        это даст больше шансов на&nbsp;успешную индексацию проекта. На&nbsp;старте
                        работы с&nbsp;проектом мы&nbsp;предоставляем аудит, в&nbsp;котором подробно
                        рассматриваем:
                    </CommonUsualText>
                    <CommonOlList
                        className="mts-invest-tech-audit__list"
                        CommonOlList={mtsInvestList}
                    />
                    <CommonSmallText>
                        Также во&nbsp;время аудита сразу ставим проект на&nbsp;мониторинг изменения
                        и&nbsp;доступности, продление сертификата безопасности и&nbsp;домена.
                        Из&nbsp;выявленных проблем составляем рекомендации и&nbsp;способы
                        их&nbsp;исправления в&nbsp;порядке приоритетов. Каждую поставленную нами
                        задачу проверяем на&nbsp;корректность внедрения или исправления.
                    </CommonSmallText>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default TechAudit;
